import { Injectable } from '@angular/core';
const Swal = require('sweetalert2');

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor() {}

  // ------------------ Sweet Alert ------------------
  alertSuccess(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'success',
      confirmButtonText: 'OK',
    });
  }

  alertError(title: string, text: string = 'Please try again.') {
    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText: 'OK',
    });
  }

  alertWarning(title: string, text: string = 'Please check again.') {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  }

  alertInfo(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'info',
      confirmButtonText: 'OK',
    });
  }

  alertQuestion(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'question',
      confirmButtonText: 'OK',
    });
  }

  alertConfirm(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
    });
  }
  // ----------------------------------------------
  // ---------------Timer Alert -----------------
  alertMessage(
    title: string,
    text: string,
    typeSuccess: boolean = true,
    timer: number = 3,
    info: boolean = false
  ) {
    return Swal.fire({
      title,
      text,
      timer: timer * 1000,
      timerProgressBar: true,
      showConfirmButton: false,
      showCancelButton: false,
      position: 'top-end',
      outsideClick: true,
      toast: true,
      icon: info ? 'info' : typeSuccess ? 'success' : 'error',
    });
  }
  // ----------------------------------------------

  deepCloning(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  removeDuplicates(arr: any) {
    return arr.filter((v: any, i: any) => arr.indexOf(v) === i);
  }
}
